module.exports = "<div class=\"modal-archismall\">\n    <div class=\"modal-header\">\n        <h3 class=\"modal-title\">\n            Errore ArchiSMALL\n        </h3>\n    </div>\n\n    <div class=\"modal-body\">\n        Si è verificato un problema durante il richiamo dei servizi ArchiSMALL.\n        <br/> Dopo {{attempts}} tentativi i servizi continuano a non rispondere.\n        <br/> Vuoi continuare a provare?\n    </div>\n\n    <div class=\"modal-footer\">\n        <a ng-click=\"cancel();\">No</a>\n        <a ng-click=\"retry();\">Si</a>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/components/retry-ws-modal/retry-ws-modal.html
// module id = 1372
// module chunks = 0